import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'initialCaps'
})
export class InitialCapsPipe implements PipeTransform {

  transform(value: string, args?: any): string {
    return value.replace(/[^|\.|\!|\?/]+/g, function(c, a, d) {
      return 0 > d.charAt(a - 1).search(/[^\s-]/) ? c.charAt(0).toUpperCase() + c.substr(1).toLowerCase() : " " + c.charAt(1).toUpperCase() + c.substr(2).toLowerCase();
    });
  }

}
